/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/anchor-has-content */
import React, { useRef, useState } from "react";
import { Popover } from "@material-ui/core";
import { toAbsoluteUrl } from "../../_metronic/utils/utils";

import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import CloseIcon from '@material-ui/icons/Close';
import { getOrderDetails,createOrderPaymentLink,PAYMENT_SOCKET_URL,USDFormat} from "../crud/auth.crud";
import { parse } from "date-fns";
import WebSocket from 'isomorphic-ws';
import Alert from '@material-ui/lab/Alert'
import { Tooltip } from "@material-ui/core";
import {  format } from 'date-fns'

import CircularProgress from '@material-ui/core/CircularProgress';


export default function OrderPayment({onClose,order,onPayment, permission}) {
  
 const [orderDetails,setOrderDetails] = useState([]);
  const [loading,setLoading] = useState(false);
 const [total,setTotal] = useState(0);
 const [link,setLink] = useState(null);
 const [paymentLoading,setPaymentLoading] = useState(false);
 const [paymentStatus,setPaymentStatus] = useState(order.paidStatus);

 const [seconds, setSeconds] = useState(300); // 5 minutes * 60 seconds
  const [isActive, setIsActive] = useState(false);

  React.useEffect(() => {
    let intervalId;

 if (isActive) {
  intervalId = setInterval(() => {
    setSeconds((prevSeconds) => prevSeconds - 1);
  }, 1000);
}

return () => clearInterval(intervalId);
}, [isActive]);


React.useEffect(() => {
          const fetch = async () => {
              try {
               setLoading(true);
 
                 let details = [];
                  const response = await getOrderDetails(order.id);
                  details = response.data;
               
                //console.log("final:::",details);
                //setIntervalz(parseInt(intervalz));
               
                let total= 0.0;
                details.map((sr)=>{
                   total = parseFloat(total) + parseFloat(sr.finalAmount);
                 
                })
                setOrderDetails(details);
                setTotal(total);
                setLoading(false);
  
              } catch (e) {
                  console.log(e);
                  setLoading(false);
                  
              }
          };
          fetch();
      }, []);

React.useEffect(() => {
if (seconds === 0) {
  setIsActive(false);
  setPaymentLoading(false);
  setPaymentStatus(false);
}
}, [seconds]);

const toggleTimer = () => {
setIsActive(!isActive);
};

const resetTimer = () => {
setSeconds(300);
setIsActive(false);
};

const formatTime = (timeInSeconds) => {
const minutes = Math.floor(timeInSeconds / 60);
const remainingSeconds = timeInSeconds % 60;
return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
};

 

     const paymentInvoke=()=>{
      createOrderPaymentLink(order.id)
      .then(resp => {
        setPaymentLoading(true);
        //onPayment(resp.href);
        console.log(resp);
        console.log(resp.data.href);
        if(resp.data.checkoutSessionId!==null && resp.data.href!==null)
            {
              toggleTimer();
               //websocket
               const websocket = new WebSocket(PAYMENT_SOCKET_URL +order.id);

               websocket.addEventListener('open', function (event) {
                   //console.log("socket open")
                   console.log(event);
 
               });
 
               websocket.addEventListener('message', async function (event) {
                 console.log('Message from server ', event.data);
                 if (event.data.includes("APPROVED")) {
                   setPaymentLoading(false);
                   setPaymentStatus(true);
                   onPayment(order);
                 
                 }
               });
 
               websocket.addEventListener('error', function (event) {
                 console.log(event)
                 setPaymentLoading(false);
               });
 
               websocket.addEventListener('close', function (event) {
                 console.log("socket close")
                 setPaymentLoading(false);
               });
 
 
            
            setLink(resp.data.href);
            window.open(
              resp.data.href,
              '_blank',
              'width=600,height=400'
            );
          }
      })
      .catch(() => {
        setLoading(false);
      })
     }
 

  return (
    <>
      <div className="kt-portlet kt-portlet--height-fluid">
        <div className="kt-portlet__head">
          <div className="kt-portlet__head-label">
            <h3 className="kt-portlet__head-title">Invoice for {'(#'+order.orderKey+')'}</h3>
          </div>
          <div className="kt-portlet__head-toolbar">
           
            <a href="#" onClick={onClose}><CloseIcon style={{ color: '#5867dd',fontSize: 25}} /> </a>
          </div>
        </div>

        <div className="kt-portlet__body">
          <div className="kt-widget kt-widget--user-profile-3">
                      <div className="kt-widget__top">
                          <div className="kt-widget__content">
                                <div className="kt-widget__subhead">
                                      <Tooltip title="Ordered By"><a href='#' ><i className="flaticon2-calendar-3"></i>{order.accountName}</a></Tooltip>
                                      <Tooltip title="Order Date"><a href='#' ><i className="flaticon2-calendar-6"></i>{format(new Date(order.createdOn), 'MM/dd/yyyy')} </a></Tooltip>
                                      <Tooltip title="Requested User"><a href='#' ><i className="flaticon2-user-1"></i>{order.requestedBy} </a></Tooltip>
                                </div>
                            </div>
                      </div>
                    </div>
          {loading ===false &&
          <div className="kt-widget4">
          <div className="kt-widget4__item">
              
              <div className="kt-widget4__info">
                <a
                  className="kt-widget4__username"
                  href="#"
                />
                <a
                  className="kt-widget4__title"
                  href="#"
                >
                   Product
                </a>
                <p className="kt-widget4__text"></p>
              </div>
              <span className="kt-widget4__number kt-font-brand">Amount</span>
            </div>
            {/**loading &&
                          <div style={{alignItems: "center",display: 'flex', justifyContent: 'center',height: "100vh", width: "100vw"}}>
                            <CircularProgress />
                                   
              </div>
                                  */}
          {orderDetails.map((od)=>(
            <div className="kt-widget4__item" key={od.id}>
              
              <div className="kt-widget4__info">
                <a
                  className="kt-widget4__username"
                  href="#"
                />
                <a
                  className="kt-widget4__title"
                  href="#"
                >
                   {od.product.productName}
                </a>
                <p className="kt-widget4__text">{'Quantity - '+od.finalQuantity}</p>
              </div>
              <span className="kt-widget4__number" style={{color:'green'}}>{USDFormat(od.finalAmount)}</span>
            </div>
           ))}
            <div className="kt-widget4__item">
              <div className="kt-widget4__pic kt-widget4__pic--pic">
                
              </div>
              <div className="kt-widget4__info">
                <a
                  className="kt-widget4__username"
                  href="#"
                />
                <a
                  className="kt-widget4__title"
                  href="#"
                >
                   Total
                </a>
                <p className="kt-widget4__text"></p>
              </div>
              <span className="kt-widget4__number"  style={{color:'green'}}>{USDFormat(total)}</span>
            </div>
          </div>
          }
          {loading===true && 
              <div style={{alignItems: "center",display: 'flex', justifyContent: 'center'}}>
                  <CircularProgress />
              </div>
          }
        </div>
        <div className="kt-portlet__foot">
                    {!paymentLoading && paymentStatus===false && permission.includes("PAY:ORDERINVOICE") &&
                    <Button
                        variant="outlined"
                        color="primary"
                        endIcon={<Icon>send</Icon>}
                        onClick={paymentInvoke}
                       
                        style={{'margin':'5px'}}
                        >
                        PAY ONLINE
                      </Button>
                      }
                      {paymentStatus===true &&
                        <Alert severity="info">Payment Received</Alert>
                      }  
                     
                      {paymentLoading &&
                          <div style={{alignItems: "center",display: 'flex', justifyContent: 'center'}}>                            
                            <Alert icon={<CircularProgress size={15} />}>&nbsp;&nbsp;Payment initiated.Please wait for {formatTime(seconds)}</Alert>      
                          </div>
                      }
                               
                
        </div>
        
        
        
      </div>
    </>
  );
}
